
<template>
    <div >
        <div >
            <form @submit.prevent="gps_submit">
            <l-map ref="map" 
                style="height: 450px;" :zoom="zoom"  :center="center" :bounds="mbounds"
                >
                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            </l-map>
            
                <table class="table text-center font-weight-light table-borderless " style="margin-top: 10px; margin-bottom: 0px;">
                     <tr>
                        <td  class="align-middle; " style="text-align: left; font-weight: bold; padding: 5px; "> 
                           Longitude:
                        </td>
                        <td  class="align-middle " style="text-align: left; font-weight: bold; padding: 5px;"> 
                           Latitude:
                        </td>
                        <td  class="align-middle " style="text-align: left; font-weight: bold; padding: 5px;"> 
                           Rayon (Km):
                        </td>
                    </tr>
                    <tr>
                        <td class="align-middle" style="padding: 1px;">
                          <input type="text" id="longitude" class="form-control border-color not-allowed "  ref="longitudeInput"
                                placeholder="Entrer une valeur" 
                                required
                                @keypress="check_coordinates($event)"
                                @keyup.delete="updateMarker()"
                                v-model="coordinates.longitude"
                                maxlength="10"
                                pattern="^-?\d{2}\.\d+$|-?\d{3}\.\d+$|-?\d{1}\.\d+$|-?\d{2}|-?\d{3}|-?\d{1}" 
                                title= "Entrer un nombre entier ou decimal positif ou negatif avec tout au plus 3 chiffres dans la partie entière"
                                >
                                <span id="error-lng"></span>
                                <!--permet de saisir des valeurs de -180 à 180 autorise 2 chiffres avant le point-->
                        </td>
                        <td class="align-middle" style="padding: 1px;">
                           <input type="text" id="latitude" class="form-control border-color not-allowed "  ref="latitudeInput"
                                placeholder="Entrer une valeur" 
                                required
                                @keypress="check_coordinates($event)"
                                @keyup.delete="updateMarker()"
                                v-model="coordinates.latitude" 
                                maxlength="10"
                                pattern="^-?\d{2}\.\d+$|-?\d{1}\.\d+$|-?\d{2}|-?\d{1}" 
                                title= "Entrer un nombre entier ou decimal positif ou negatif avec tout au plus 2 chiffres dans la partie entière"
                                >
                                <span id="error-lat"></span>
                                <!--permet de saisir des valeurs de -90 à 90 autorise que deux chiffres avant le point -->
                        </td>
                        <td class="align-middle" style="padding: 1px;">
                            <input type="text" id="radius" class="form-control border-color not-allowed " 
                                @keypress="check_coordinates_rayon($event)"
                                @keyup.delete="updateMarker()"
                                placeholder="Entrer une valeur" 
                                required
                                v-model="coordinates.rayon"
                                maxlength="5"
                                pattern="^(?=.*[1-9])[0-9]*$|[1-9][0-9]*|^(?=.*[1-9])\d{3}\.\d+$|^(?=.*[1-9])\d{2}\.\d+$|^(?=.*[1-9])\d{1}\.\d+$"
                                title= "Entrer un nombre entier ou décimal positif avec tout au plus 3 chiffres après la virgule et au moins un chiffre avant la virgule sans dépasser 600"
                            >
                            <span id="error-message"></span>
                        </td>
                    </tr>

                    <tr>
                        <td colspan="3" style="padding: 1px;">
                            <div  class="text-center mt-2 " >    
                                <b-button class="btn btn-default mr-3" :disabled="isBusy" @click="$emit('gps-alarm-done',{'error' : true,})">Annuler</b-button>
                                <!--<b-button v-if="this.gps_alarm.id" class="btn btn-default mr-3"  variant="danger" :disabled="isBusy" @click="supprimer()"> Supprimer Alarme </b-button>
                                <b-button class="btn btn-default mr-3" variant="secondary" :disabled="isBusy" @click="annuler()"> Annuler </b-button>-->
                                <b-button  type="submit" class="btn btn-primary"> Appliquer </b-button>     
                            </div>
                            <div class="alert alert-danger" role="alert" v-if="error">
                                Impossible d'ajouter une alarme seuil ! Veuillez contacter KEMTAG
                                <i class="ti-close float-right mt-1" @click="error = false"></i>
                            </div> 
                        </td>
                    </tr>
                
                </table>
            </form>
        </div>
<!-- ######################################################################################### -->
    </div>
</template>

<script>
import {latLng} from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LCircle, LPopup } from 'vue2-leaflet';
import { mapGetters } from 'vuex';
import api from "../../config/_api";
import { mapActions } from 'vuex';

export default {
    name: 'SelectGpsAlarm',
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LCircle
    },
    data() {
        return {
            initial_longitude:null,
            initial_latitude: null,
            initial_rayon: 0,
            error: false, // initialiser l'objet error {pour la fonction alerte}  
            marker: null,
            radius: 0,
            circle: null,
            coordinates: {
                latitude: null,
                longitude: null,
                rayon: null,
            },
            isBusy: false,
            
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            mbounds: null,
            center: { lat: 48.117266, lng:  -1.677792}, // Coordonnées de Rennes par défaut
            defaultZoom: 12, // Zoom par défaut
            currentMarker:  {
                latitude: null,
                longitude: null,
                rayon: null
            },
        }
    },
    props :{
        selected_system: {
            type: Object,
            required: false
        },
        gps_alarm : {
            type: Object,
            required: false
        },
        action : "",
    },
    computed: {
		...mapGetters({ 
            structure : 'structure/structure',
            system_alarm_gps: 'system_alarm_gps/system_alarm_gps',
        }),
        zoom() {
            if((this.coordinates.rayon == null) || this.coordinates.rayon == 0){
                return this.defaultZoom;
            }
            else{
                return Math.min(14,parseInt(Math.log2(591657550.5 / (parseFloat(this.coordinates.rayon) *1000 * 180))) + 2);
            }
        }
	},
    mounted() {
       if (this.gps_alarm.id!=0) {
            this.coordinates.latitude = this.gps_alarm.latitude;
            this.coordinates.longitude = this.gps_alarm.longitude;
            this.coordinates.rayon = this.gps_alarm.rayon;
            this.updateMarker();
            
            //redondant mais sinon ça fonctionne pas
            const lat = parseFloat(this.coordinates.latitude);
            const lng = parseFloat(this.coordinates.longitude);
            this.center = { lat, lng};

            //on recupère les valeurs du popup systemAlert pour eviter d'annuler les modifs sans confirmation
            /*this.initial_longitude = parseFloat(parseFloat(this.gps_alarm.longitude).toFixed(Math.min(6, (this.gps_alarm.longitude.toString().split('.')[1] || '').length)));
            this.initial_latitude = parseFloat(parseFloat(this.gps_alarm.latitude).toFixed(Math.min(6, (this.gps_alarm.latitude.toString().split('.')[1] || '').length)));
            this.initial_rayon = this.gps_alarm.rayon;*/
        }
       /* else{
            this.$nextTick(() => {
            // autres actions à effectuer après le montage
                this.$refs.map.center = this.center;
            });
        }*/
       
        // ajouter un écouteur d'événements pour le clic sur la carte
        this.$refs.map.mapObject.on("click", (e) => {
            // Mettez à jour la propriété calculée "computedcoordinates.longitude"
            this.coordinates = {
                ...this.coordinates, // Copiez les autres propriétés de coordinates
             //fixe les coordonnées à 6 chiffres max après la virgule
                longitude: parseFloat(e.latlng.lng.toFixed(Math.min(6, (e.latlng.lng.toString().split('.')[1] || '').length))),
                latitude: parseFloat(e.latlng.lat.toFixed(Math.min(6, (e.latlng.lat.toString().split('.')[1] || '').length))),
            };
            this.updateMarker();
        });
 
        setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
            this.updateMarker();
        }.bind(this), 200);
        
    },
    created() {
        this.$store.dispatch('system_alarm_gps/getSysAlarmGps');
    },
  
    watch: {
        currentMarker(newVal) {
            if (newVal) {
                const lng = newVal.getLatLng().lng;
                const lat = newVal.getLatLng().lat;
            
                if (Number.isInteger(lng)) {
                    this.coordinates.longitude = lng;
                } else  {
                    this.coordinates.longitude = lng.toFixed(Math.min(6, lng.toString().split('.')[1].length));
                }
                
                if (Number.isInteger(lat)) {
                    this.coordinates.latitude = lat;
                } else  {
                    this.coordinates.latitude = lat.toFixed(Math.min(6, lat.toString().split('.')[1].length));
                }
            } 
            else {
                this.coordinates.longitude = '';
                this.coordinates.latitude = '';
            }
        }
    },
     methods: {
         ...mapActions('system_alarm_gps', ['getSystemAlarmGps']),
       
        check_coordinates: function(event){

            // Vérifier si l'utilisateur a saisi un zéro après le point
            const input = event.target;
            const inputValue = input.value;
            const dotIndex = inputValue.indexOf('.');
            const cursorIndex = input.selectionStart;
             //permet de saisir des 0 apres la virgule pour latitude et longitude
            if (event.keyCode === 48) {
                if (dotIndex !== -1 && cursorIndex > dotIndex) {
                    // Le curseur est positionné après le point, on ne fait rien.
                    return;
                }
            }

            // autoriser les chiffres et le signe moins et les nombres décimaux
            if (((event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 45 || event.keyCode === 46) || ((event.which >= 48 && event.which <= 57) || event.which === 45 || event.which === 46)) {
                // autoriser le signe moins uniquement au début de l'input
                if (event.keyCode === 45 || event.which === 45) {
                    if (event.target.selectionStart !== 0 || event.target.value.indexOf('-') !== -1) {
                        event.preventDefault();
                        return false;
                    }
                }
                // autoriser la saisie de chiffres ou d'un seul point si le point n'est pas déjà présent
                if (event.keyCode === 46 || event.which === 46) {
                    if (event.target.value.indexOf('.') === -1) {
                        this.updateMarker();
                        return true;
                    } else {
                        event.preventDefault();
                        return false;
                    }
                }
                 
                this.updateMarker();
                return true;
            }
            if (event.code === 'Backspace') {
                this.updateMarker();
                return true;
            }
            // empêcher toutes les autres touches
            event.preventDefault();
            this.zoom;
            return false;
        },
       
        check_coordinates_rayon: function(event){
           // autoriser les chiffres  et les nombres décimaux
            if (((event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 46) || ((event.which >= 48 && event.which <= 57) || event.which === 46)) {
                // autoriser la saisie de chiffres ou d'un seul point si le point n'est pas déjà présent
                if (event.keyCode === 46 || event.which === 46) {
                    if (event.target.value.indexOf('.') === -1) {
                        this.updateMarker();
                        return true;
                    } else {
                        event.preventDefault();
                        return false;
                    }
                }
                this.updateMarker();
                return true;
            }
            if (event.code === 'Backspace') {
                this.updateMarker();
                return true;
            }
            
            // empêcher toutes les autres touches
            event.preventDefault();
            this.zoom;
            return false;
        },
        
       
        updateMarker() {
            setTimeout(function() {
                let radiusInput = document.getElementById("radius");
                let lngInput = document.getElementById("longitude");
                let latInput = document.getElementById("latitude");
                let errorSpan = document.getElementById("error-message");
                let errorSpan1 = document.getElementById("error-lng");
                let errorSpan2 = document.getElementById("error-lat");
                //ne pas faire de update si on a un point
                if( (this.coordinates.longitude != null) && ( typeof this.coordinates.longitude === "string")){
                    // Vérifier si le dernier caractère de longitude est un point
                    const lastChar = this.coordinates.longitude.slice(-1);
                    if (lastChar === '.') {
                        return;
                    }
                }
                if( (this.coordinates.latitude != null) && ( typeof this.coordinates.latitude === "string")){
                    // Vérifier si le dernier caractère de longitude est un point
                    const lastChar = this.coordinates.latitude.slice(-1);
                    if (lastChar === '.') {
                        return;
                    }
                }
                
                // obtenir les nouvelles coordonnées
                const lat = parseFloat(this.coordinates.latitude);
                const lng = parseFloat(this.coordinates.longitude);
                const radius = parseFloat(this.coordinates.rayon);
                
                setTimeout(function() {
                    this.zoom;
                }.bind(this), 250);

                // TODO EMPECHER SI RADIUS>600 
                if (radius > 600) {
                    radiusInput.classList.add("error");
                    errorSpan.textContent = "Le rayon ne peut pas dépasser 600.";
                    if (this.circle) {
                        this.$refs.map.mapObject.removeLayer(this.circle);
                    }
                    return;
                } else {
                    radiusInput.classList.remove("error");
                    errorSpan.textContent = "";
                }
                //TODO EMPECHER SI LNG NOT IN [-180,180]
                if(lng < -180 || lng > 180){
                    errorSpan1.textContent = "La longitude doit être comprise entre -180 et 180 degré";
                    if (this.currentMarker) {
                        this.$refs.map.mapObject.removeLayer(this.currentMarker);
                        if (this.circle) {
                            this.$refs.map.mapObject.removeLayer(this.circle);
                        }
                    }
                    return;
                }
                else {
                    lngInput.classList.remove("error");
                    errorSpan1.textContent = "";
                }
                //TODO EMPECHER SI Lat NOT IN [-90,90]
                if(lat < -90 || lat > 90){
                    errorSpan2.textContent = "La latitude doit être comprise entre -90 et 90 degré";
                    if (this.currentMarker) {
                        this.$refs.map.mapObject.removeLayer(this.currentMarker);
                        if (this.circle) {
                            this.$refs.map.mapObject.removeLayer(this.circle);
                        }
                    }
                    return;
                }
                else {
                    latInput.classList.remove("error");
                    errorSpan2.textContent = "";
                }

                // vérifier si les nouvelles coordonnées sont valides
                if (!isNaN(lat) && !isNaN(lng)) {
                    this.center= { lat, lng} // actualisation du centre avec le nouveau marker
                    // supprimer l'ancien marqueur et cercle s'ils existent
                    if (this.currentMarker) {
                        this.$refs.map.mapObject.removeLayer(this.currentMarker);
                    }
                    if (this.circle) {
                        this.$refs.map.mapObject.removeLayer(this.circle);
                    }
                    // créer un nouveau marqueur à la nouvelle position
                    this.currentMarker = L.marker([lat, lng]).addTo(this.$refs.map.mapObject);

                    // créer un cercle autour du marqueur avec un rayon en km

                    this.circle = L.circle([lat, lng], { radius: this.coordinates.rayon*1000 }).addTo(this.$refs.map.mapObject);

                    // émettre un événement pour signaler la mise à jour du marqueur
                    this.$emit('marker-updated', { lat, lng });
                }
            }.bind(this), 50);
            
        },
        //demande de confirmation avant d'annuler
        /*annuler(){
            //this.initial_longitude=this.initial_longitude.toFixed(Math.min(6, (this.initial_longitude.toString().split('.')[1] || ''.length)));
            if((this.coordinates.longitude!=this.initial_longitude)||(this.coordinates.latitude!=this.initial_latitude)||(this.coordinates.rayon!=this.initial_rayon)){

                //console.log('La valeur du sélecteur "type de matériel" a changé !');
                this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir annuler les modifications ?', {
					title: 'Annuler les modifications',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Confirmer',
					cancelTitle: 'Annuler',
					footerClass: 'p-2',
					hideHeaderClose: false,
                    centered: true,
                    
				}).then(value => {
					if(value) {
                      this.$emit('map3-done')
                    }
                    
				})
            }
            else{
                this.$emit('map3-done')
            }
            
        },
        //si plusieurs alarmes
        supprimer(){
            let url = api.url + 'sysAlarmGps/delete/' +  this.gps_alarm.id;

                this.axios({url: url, method: 'POST' })
                    .then(resp => {
                        if(resp.status <400){
                            this.$emit('map3-done',{'error' : false,'resp' : resp});
                        }
                    })
                    .catch(err => {
                        this.error = true; 
                        //console.log(err);
                         this.$emit('map3-done',{'error' : true,'resp' : err});
                    });
                
        },*/
   
        gps_submit() {
            let data = {
                radius: this.coordinates.rayon,
                longitude: this.coordinates.longitude,
                latitude: this.coordinates.latitude,
            };
            // vérifier si le rayon dépasse 600
            let radiusInput = document.getElementById("radius");
            let errorSpan = document.getElementById("error-message");
            if (this.coordinates.rayon > 600) {
                radiusInput.classList.add("error");
                errorSpan.textContent = "Le rayon ne peut pas dépasser 600.";
                return; // arrêter ici si le rayon est trop grand
            } else {
                radiusInput.classList.remove("error");
                errorSpan.textContent = "";
            }
            // vérifier si SI LNG NOT IN [-180,180]
            let lngInput = document.getElementById("longitude");
            let errorSpan1 = document.getElementById("error-lng");
             if(this.coordinates.longitude < -180 || this.coordinates.longitude > 180){
                lngInput.classList.add("error");
                errorSpan1.textContent = "La longitude doit être comprise entre -180 et 180 degré";
                return; 
            } else {
                lngInput.classList.remove("error");
                errorSpan1.textContent = "";
            }
            // vérifier si SI Lat NOT IN [-90,90]
            let latInput = document.getElementById("latitude");
            let errorSpan2 = document.getElementById("error-lat");
             if(this.coordinates.latitude < -90 || this.coordinates.latitude > 90){
                latInput.classList.add("error");
                errorSpan2.textContent = "La latitude doit être comprise entre -90 et 90 degré";
                return; 
            } else {
                latInput.classList.remove("error");
                errorSpan2.textContent = "";
            }
            //si l'alarme existe déjà sur le system faire un update lorsqu'on valide
            //verifier si computed_alarme.id! =0 alarme sur le system existe
            if(this.gps_alarm.id!=0){
                this.$store.dispatch('system_alarm_gps/update', {
                    id: this.gps_alarm.id,
                    longitude: data.longitude,
                    latitude: data.latitude,
                    rayon: data.radius,
                }).then(resp => {
                    this.$emit('gps-alarm-done',{'error' : false,'resp' : resp});
                }).catch((error) => {
                    this.error = true; 
                    //console.log(err);
                })
            }
            else {
                this.$store.dispatch('system_alarm_gps/create', {
                    system_id: this._props.selected_system.id,
                    longitude: data.longitude,
                    latitude: data.latitude,
                    rayon: data.radius,
                }).then(resp => {
                    this.$emit('gps-alarm-done',{'error' : false,'resp' : resp});
                }).catch((error) => {
                    this.error = true; 
                    //console.log(err);
                })
            }
        },
    },
}
</script>
